export type DadosGarantias = {
  FiancaBancariaTerreno: boolean
  SeguroGarantiaUrbanizacao: boolean
  SeguroGarantiaPermutaFisica: boolean
}

export const dadosGarantiasValorDefault = {
  FiancaBancariaTerreno: false,
  SeguroGarantiaUrbanizacao: false,
  SeguroGarantiaPermutaFisica: false
} as DadosGarantias
